import DocumentationButton from "components/DocumentationButton";
import { EmptystateSearchNoResultsColored } from "components/icons/generated";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import PageInfoHeader from "ds/components/PageInfoHeader";
import { useInitialSort } from "ds/components/Table/hooks/useInitialSort";
import TableSimple from "ds/components/TableSimple";
import useAnalytics from "hooks/useAnalytics";
import useTitle from "hooks/useTitle";
import { BlueprintIntegrationAttachment } from "types/generated";
import { getDocsUrl } from "utils/getDocsUrl";

import { INTEGRATION_USED_BY_TABLE_CELLS } from "./Table/Cells";
import {
  INITIAL_SORT_DIRECTION,
  INITIAL_SORT_OPTION,
  INTEGRATION_USED_BY_TABLE_FILTERS_STORAGE_KEY,
  SORT_CONFIG,
} from "./Table/constants";
import { useSortingIntegrationUsedBy } from "./Table/useSortingIntegrationUsedBy";
import useIntegrationUsedByTableStore from "./Table/useTableStore";

type IntegrationUsedByProps = {
  name: string;
  attachedBluePrints: BlueprintIntegrationAttachment[];
  loading: boolean;
};

const IntegrationUsedBy = ({ name, attachedBluePrints, loading }: IntegrationUsedByProps) => {
  const trackAnalytics = useAnalytics();

  useInitialSort(INITIAL_SORT_OPTION, INITIAL_SORT_DIRECTION);

  useTitle(`Used by · ${name}`);

  const { filteredBlueprints } = useSortingIntegrationUsedBy(attachedBluePrints);

  return (
    <>
      <PageInfoHeader title="Used by" />

      <TableSimple
        data={filteredBlueprints}
        loading={loading}
        store={useIntegrationUsedByTableStore}
        ariaLabel="Integration used by list"
        trackAnalytics={trackAnalytics}
        cellPerColumn={INTEGRATION_USED_BY_TABLE_CELLS}
        filtersStorageKey={INTEGRATION_USED_BY_TABLE_FILTERS_STORAGE_KEY}
        sortConfig={SORT_CONFIG}
        hasPagination={false}
        emptyState={
          <Box align="center" justify="center" grow="1" fullWidth>
            <EmptyState
              padding="large"
              icon={EmptystateSearchNoResultsColored}
              title="No blueprints using this integration"
            >
              <Box gap="medium">
                <DocumentationButton
                  to={getDocsUrl("/integrations/webhooks")}
                  label="Documentation"
                />
              </Box>
            </EmptyState>
          </Box>
        }
      />
    </>
  );
};

export default IntegrationUsedBy;
